<template >
<v-card-actions class="justify-center">
  <v-btn dark color="primary" @click="onClick(params)" class="mb-2">
    {{buttonText}}
  </v-btn>
</v-card-actions>
</template>
<script>
export default {
  name: 'groupFooterButton',
  props: {
    buttonText: {
      type: String
    },
    onClick: {
      type: Function
    },
    params: {
      type: Object
    },
    groupColSpan: {
      type: Number,
      default: 3
    },
    inputWidth: {
      type: Number
    },
    inputHeight: {
      type: Number
    },
    bold: {
      type: Boolean
    }
  },
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>